import React from 'react';
import { Button } from '@zen-common/components-base';

const SettingButton = (props) => <Button bg="secondary" width="100%" {...props} />;

export default SettingButton;
